import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getBlowingReportStart,
  getBlowingReportSuccess,
  getBlowingReportFailure,
} from "../reducers/getBlowingReportReducer";
import axios from "axios";
import Cookies from "js-cookie";

export const getBlowingReport = createAsyncThunk(
  "getBlowingReport",
  async (_, thunkAPI) => {
    try {
      thunkAPI.dispatch(getBlowingReportStart());
      const token = Cookies.get("token");

      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}api/BlowingForm/GetReports`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const responseData = await response;

      thunkAPI.dispatch(getBlowingReportSuccess(responseData?.data?.result));

      return responseData;
    } catch (error) {
      thunkAPI.dispatch(getBlowingReportFailure(error.response.data.Message));

      throw error;
    }
  }
);
